import React from "react";
import { Box, ButtonBase, Paper, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const getPlaylistName = (index, totalCount) => {
  if (totalCount === 1) return "Main Playlist";
  if (index === 0) return "Playlist 1";
  if (index === 1) return "Playlist 2";
  return `Additional Playlist ${index - 1}`;
};

const PlaylistPlaceholder = ({
  index,
  totalCount,
  onClick,
  onCreateClick,
  playlist,
}) => {
  const actionTileSx = {
    width: "33%",
    aspectRatio: "1 / 1",
    maxWidth: "132px",
    maxHeight: "132px",
    minWidth: "110px",
    minHeight: "110px",
    border: "1px solid rgba(0, 0, 0, 0.65)",
    borderRadius: "6px",
    backgroundColor: "transparent",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
    transition: "background-color 0.2s, border-color 0.2s, transform 0.2s",
    "&:hover": {
      backgroundColor: "#d6c4ff",
      borderColor: "rgba(0, 0, 0, 0.85)",
      transform: "translateY(-1px)",
    },
  };

  return (
    <Paper
      elevation={0}
      onClick={playlist ? onClick : undefined}
      sx={{
        width: "100%",
        height: "400px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        cursor: playlist && onClick ? "pointer" : "default",
        backgroundColor: "#f0e6ff",
        borderRadius: "8px",
        transition: "background-color 0.2s",
        "&:hover": {
          backgroundColor: "#e6d9ff",
        },
      }}
    >
      {playlist ? (
        <Box sx={{ p: 4, width: "100%", height: "100%" }}>
          <Typography variant="h5" color="#4b445b" gutterBottom>
            {getPlaylistName(index, totalCount)}
          </Typography>
          <Typography
            variant="body1"
            color="#4b445b"
            sx={{ mt: 2, opacity: 0.8 }}
          >
            {`${playlist?.playlist?.length || 0} songs`}
          </Typography>
          <Typography
            variant="body1"
            color="#4b445b"
            sx={{ mt: 1, opacity: 0.8 }}
          >
            {playlist?.startTime && playlist?.endTime ? (
              <>
                {new Date(playlist.startTime).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
                {" - "}
                {new Date(playlist.endTime).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </>
            ) : null}
          </Typography>
        </Box>
      ) : (
        <>
          <Typography variant="h5" color="#4b445b" sx={{ opacity: 0.8, mb: 3 }}>
            {getPlaylistName(index, totalCount)}
          </Typography>
          <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            <ButtonBase onClick={onCreateClick} sx={actionTileSx}>
              <AddIcon sx={{ fontSize: 36, color: "#4b445b", opacity: 0.9 }} />
              <Typography variant="body2" color="#4b445b">
                Create
              </Typography>
            </ButtonBase>
          </Box>
        </>
      )}
    </Paper>
  );
};

export default PlaylistPlaceholder;
